module.exports = __webpack_public_path__ + "static/media/SmartBooking.cc599c94.png";